import type { CreditProfile } from '@/shared/api/resources';
import { formatCivilDate } from '@/shared/lib/format';

/** De onde veio um campo preenchido pelo automatico, pelo valor gravado (ADR 0101). */
const fontes: Record<string, string> = {
  consulta: 'Da consulta SeguraCoreCredit',
  motor: 'Do motor de credito',
  receita_federal: 'Da Receita Federal pela SeguraCoreData',
};

/**
 * A origem de um campo do perfil em texto curto. Vazio quando o campo nao veio do
 * automatico: esta digitado, ou em branco. A origem e sempre a do servidor.
 */
export function textoDaOrigem(
  perfil: CreditProfile | undefined,
  campo: string,
): string {
  const origem = perfil?.field_origins?.[campo];
  if (!origem) return '';
  const fonte = fontes[origem.source] ?? 'Preenchido pelo automatico';
  const data = formatCivilDate(origem.reference_date);
  return data ? `${fonte} em ${data}` : fonte;
}
